<template>
  <v-container v-if="noData">
    <div class="text-xs-center">
    <h2>No articles found</h2>
    </div>
  </v-container>

  <v-container v-else fluid grid-list-md class="news-container">
    <v-layout row wrap>
      <v-flex d-flex
        v-for="(item, idx) in articles[0].items"
        :key="idx"
        class="pa-2"
      >
        <v-card class="news-card" hover data-aos="zoom-in" data-aos-easing="ease"
          :href="item.link" target="_blank" rel="noopener noreferrer">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card-title class="pb-0">
                  <v-flex text-xs-left class="title news-title">
                    {{item.title}}
                  </v-flex>
                  <v-flex class="body">
                    <div class="grey--text news-description">
                      <span v-html=item.description></span>
                    </div>
                  </v-flex>
              </v-card-title>
              <v-card-actions class="news-footer">
                  <v-flex class="footer">
                    <div class="news-date">
                        {{ formatDate(item.pubDate) }}
                    </div>
                  </v-flex>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as moment from 'moment/moment'
export default {
  name: 'NewsCards',
  props: ['articles', 'noData'],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('MMMM DD, YYYY')
    }
  }
}
</script>

<style scoped>
  .news-card:hover{
    text-decoration: none;
  }
  .news-description {
    text-align: left;
  }
</style>
